import { c as _c } from "react/compiler-runtime";
import Image from "@/components/common/image/image";
import imageUrl from "@/sanity/utilities/imageUrl";
import type { SanityImageSource } from "@sanity/image-url/lib/types/types";
export interface AuthorCardImageProps {
  name: string;
  image?: SanityImageSource;
}
const AuthorCardImage = props => {
  const $ = _c(3);
  const {
    name,
    image
  } = props;
  let t0;
  if ($[0] !== image || $[1] !== name) {
    t0 = image ? <Image className="h-[44px] w-[44px] shrink-0 rounded-full object-cover" src={imageUrl(image).width(44).url()} alt={name ?? ""} width={44} height={44} /> : <div className="flex items-center gap-2"><div aria-hidden="true" className="flex size-[44px] shrink-0 items-center justify-center rounded-full border-2 border-white bg-[#E0F2FE] text-[14px] font-bold leading-none text-[#0369A1] shadow-[0px_2px_4px_rgba(0,0,0,0.07)]">{name ? name.split(" ").filter(Boolean).slice(0, 2).map(_temp).join("").toUpperCase() : ""}</div></div>;
    $[0] = image;
    $[1] = name;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default AuthorCardImage;
function _temp(part) {
  return part[0];
}